/* Blazing Banner builder: phones and tablets (below 1180px).
   Adds a step progress row, puts the banner tabs on the canvas card and the order
   total right under Quantity, shows a slim order bar while that total is off screen,
   and (phones only) folds the sections below the builder into tap-to-open rows.
   No builder logic is changed; at 1180px and up every element goes back where it was. */
(function () {
  var root = document.getElementById('blazing-banner-builder-v43');
  if (!root) return;
  var wrap = root.querySelector(':scope > .wrap');
  var stage = wrap && wrap.querySelector(':scope > .stage');
  var panel = wrap && wrap.querySelector(':scope > .panel');
  if (!wrap || !stage || !panel) return;

  var mq = window.matchMedia('(max-width: 1179px)');
  var $ = function (id) { return document.getElementById(id); };
  var priceBlock = root.querySelector('.price-block');
  var addCart = $('addCartBtn');

  // Elements that move, with a marker left where each one came from.
  var moves = [
    { el: $('bannerSimpleNav'), place: function (el) { stage.insertBefore(el, stage.firstChild); } },
    { el: priceBlock, place: function (el) { var q = $('quantityStep'); if (q) q.after(el); else panel.appendChild(el); } },
    // out of the canvas card's layer, so it can sit above the steps as a bottom sheet
    { el: $('artFitInfoPopover'), place: function (el) { root.appendChild(el); } }
  ].filter(function (m) { return m.el; });

  // ---------- Step progress ----------
  var STEPS = [['sizeStep', 'Size'], ['artworkField', 'Artwork'], ['finishingStep', 'Finishing'], ['quantityStep', 'Quantity']];
  var steps = document.createElement('ol');
  steps.className = 'bbm-steps';
  steps.setAttribute('aria-label', 'Steps');
  steps.innerHTML = STEPS.map(function (s, i) {
    return '<li data-step="' + s[0] + '"><button type="button"><b>' + (i + 1) + '</b>' + s[1] + '</button></li>';
  }).join('');
  steps.addEventListener('click', function (e) {
    var li = e.target.closest('li');
    var target = li && $(li.dataset.step);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  function hasArtwork() {
    return !!(addCart && (addCart.classList.contains('ready-to-cart') || $('artworkCompactState') && $('artworkCompactState').style.display !== 'none'));
  }
  var current = 'sizeStep';
  function paintSteps() {
    var done = { sizeStep: true, artworkField: hasArtwork(), finishingStep: false, quantityStep: false };
    var idx = STEPS.findIndex(function (s) { return s[0] === current; });
    // Steps before the one in view count as done (artwork only once a file is attached)
    STEPS.forEach(function (s, i) { if (i < idx && s[0] !== 'artworkField') done[s[0]] = true; });
    if (addCart && addCart.classList.contains('ready-to-cart') && idx === STEPS.length - 1) done.quantityStep = true;
    steps.querySelectorAll('li').forEach(function (li) {
      var id = li.dataset.step;
      li.classList.toggle('is-current', id === current);
      li.classList.toggle('is-done', !!done[id] && id !== current);
      li.querySelector('button').setAttribute('aria-current', id === current ? 'step' : 'false');
    });
  }
  var stepObserver = window.IntersectionObserver && new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) current = en.target.id; });
    paintSteps();
  }, { rootMargin: '-35% 0px -55% 0px' });

  // ---------- Slim order bar (while the full order total is off screen) ----------
  var bar = document.createElement('div');
  bar.className = 'bbm-bar';
  bar.innerHTML = '<div class="bbm-bar-total"><small>Order total</small><b></b></div><button type="button" class="bbm-bar-cta"></button>';
  var barTotal = bar.querySelector('b'), barCta = bar.querySelector('button');
  barCta.addEventListener('click', function () {
    // The builder's own button checks the order: it opens the file picker when
    // artwork is missing and goes to checkout when everything is ready.
    if (addCart) addCart.click();
  });
  function paintBar() {
    var total = $('totalPrice');
    if (total && barTotal.textContent !== total.textContent) barTotal.textContent = total.textContent;
    var ready = addCart && addCart.classList.contains('ready-to-cart');
    var label = ready ? 'Checkout now' :(hasArtwork() ? 'Finish your banners' : 'Upload artwork');
    if (barCta.textContent !== label) barCta.textContent = label;
    barCta.classList.toggle('needs-artwork', !ready);
  }
  // Shown anywhere below the canvas, except while the full order total is on screen.
  var inView = { price: false, canvas: true };
  function showBar() {
    var on = active && !inView.canvas && !inView.price && stage.getBoundingClientRect().bottom < 0;
    bar.classList.toggle('is-shown', on);
    document.body.classList.toggle('bbm-bar-pad', active);
  }
  var barObserver = window.IntersectionObserver && new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.target === priceBlock) inView.price = en.isIntersecting;
      else inView.canvas = en.isIntersecting;
    });
    showBar();
  });

  var active = false;
  function enable() {
    if (active) return;
    moves.forEach(function (m) {
      m.marker = document.createComment('bbm');
      m.el.parentNode.insertBefore(m.marker, m.el);
      m.place(m.el);
    });
    var head = wrap.querySelector(':scope > .bbx-head');
    if (head) head.after(steps); else wrap.insertBefore(steps, wrap.firstChild);
    root.appendChild(bar);
    root.classList.add('bbm-on');
    active = true;
    if (stepObserver) STEPS.forEach(function (s) { if ($(s[0])) stepObserver.observe($(s[0])); });
    if (barObserver) { barObserver.observe(stage); if (priceBlock) barObserver.observe(priceBlock); }
    paint();
    refit();
  }
  function disable() {
    if (!active) return;
    moves.slice().reverse().forEach(function (m) {
      m.marker.parentNode.insertBefore(m.el, m.marker);
      m.marker.remove();
    });
    steps.remove();
    bar.remove();
    document.body.classList.remove('bbm-bar-pad');
    if (stepObserver) stepObserver.disconnect();
    if (barObserver) barObserver.disconnect();
    root.classList.remove('bbm-on');
    active = false;
    refit();
  }
  // The builder sizes its preview from the canvas box, so ask it to re-measure.
  function refit() {
    window.dispatchEvent(new Event('resize'));
    setTimeout(function () { window.dispatchEvent(new Event('resize')); }, 150);
  }

  var queued = false;
  function paint() {
    if (queued || !active) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; paintSteps(); paintBar(); showBar(); });
  }
  var mo = new MutationObserver(paint);
  ['totalPrice', 'addCartBtn', 'artworkCompactState'].forEach(function (id) {
    var el = $(id);
    if (el) mo.observe(el, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  });
  ['click', 'input', 'change'].forEach(function (ev) { root.addEventListener(ev, function () { setTimeout(paint, 0); }, true); });

  // Artwork-fit "i": place its pop-up just under the fit buttons (page position, so it doesn't follow the scroll)
  var fitBtn = $('artFitInfoBtn'), fitPop = $('artFitInfoPopover');
  function placeFit() {
    if (!active || !fitPop || fitPop.hidden) return;
    var row = $('previewActionRow') || fitBtn, r = row.getBoundingClientRect(), box = root.getBoundingClientRect();
    root.style.setProperty('--bbm-fit-top', Math.round(r.bottom - box.top + 10) + 'px');
  }
  if (fitBtn) fitBtn.addEventListener('click', function () { requestAnimationFrame(placeFit); });
  window.addEventListener('resize', placeFit);

  function sync() { mq.matches ? enable() : disable(); }
  if (mq.addEventListener) mq.addEventListener('change', sync); else mq.addListener(sync);
  sync();
  window.addEventListener('load', function () { if (active) refit(); });
})();

/* Phones: the sections below the builder become tap-to-open rows. Related sections
   (the "Banner details" tabs and the panels they switch between) share one row. */
(function () {
  var builderSection = document.getElementById('blazing-banner-builder-v43');
  builderSection = builderSection && builderSection.closest('.shopify-section');
  if (!builderSection) return;
  var mq = window.matchMedia('(max-width: 749px)');

  var ICONS = {
    star: '<path d="M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z"/>',
    ruler: '<path d="M3 17L17 3l4 4L7 21z"/><path d="M7 13l2 2M10 10l2 2M13 7l2 2"/>',
    layers: '<path d="M12 3l9 5-9 5-9-5z"/><path d="M3 13l9 5 9-5"/>',
    clock: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>',
    shield: '<path d="M12 2l8 3v6c0 5-3.4 9.4-8 11-4.6-1.6-8-6-8-11V5z"/><path d="M8.5 12l2.5 2.5 4.5-5"/>',
    chat: '<path d="M21 12a8 8 0 0 1-11.6 7.1L4 20.5l1.4-4.9A8 8 0 1 1 21 12z"/><path d="M8.5 11h.01M12 11h.01M15.5 11h.01"/>'
  };
  // Section ids from templates/product.custom-banner.json
  var GROUPS = [
    { ids: ['custom_liquid_UXq6Cq'], icon: 'star', title: 'Banners built to be seen', sub: 'Real customer banners and reviews' },
    { ids: ['custom_liquid_bbScale'], icon: 'ruler', title: 'How big is it, really?', sub: 'Your size next to a 6 ft person' },
    { ids: ['custom_liquid_bbTabs', 'custom_liquid_bbFinish', 'custom_liquid_L84DEV', 'custom_liquid_bbArt'], icon: 'layers', title: 'Banner details', sub: 'Hems, grommets, vinyl and artwork tips' },
    { ids: ['custom_liquid_Bh3kad'], icon: 'clock', title: 'Order by 1 PM, delivered in 48 hrs', sub: 'How fast-track production works' },
    { ids: ['custom_liquid_bbGuar'], icon: 'shield', title: 'Print-Right Guarantee', sub: 'If it\'s not right, we make it right' },
    { ids: ['custom_liquid_bbFaq'], icon: 'chat', title: 'Questions? Ask Kevin', sub: 'FAQs and real human support' }
  ];
  var parent = builderSection.parentNode;
  function sectionFor(id) {
    var list = parent.querySelectorAll(':scope > .shopify-section[id$="__' + id + '"]');
    return list[0] || null;
  }

  var built = [];
  function enable() {
    if (built.length) return;
    GROUPS.forEach(function (g, gi) {
      var secs = g.ids.map(sectionFor).filter(Boolean);
      if (!secs.length) return;
      var acc = document.createElement('div');
      acc.className = 'bbm-acc';
      var bodyId = 'bbm-acc-' + gi;
      acc.innerHTML =
        '<button type="button" class="bbm-acc-head" aria-expanded="false" aria-controls="' + bodyId + '">' +
          '<span class="bbm-acc-ico" aria-hidden="true"><svg viewBox="0 0 24 24">' + ICONS[g.icon] + '</svg></span>' +
          '<span class="bbm-acc-txt"><b>' + g.title + '</b><small>' + g.sub + '</small></span>' +
          '<span class="bbm-acc-chev" aria-hidden="true"></span>' +
        '</button><div class="bbm-acc-body" id="' + bodyId + '" hidden></div>';
      var body = acc.lastChild;
      var markers = secs.map(function (s) {
        var mk = document.createComment('bbm-acc');
        s.parentNode.insertBefore(mk, s);
        return { el: s, marker: mk };
      });
      secs[0].before(acc);
      secs.forEach(function (s) { body.appendChild(s); });
      acc.firstChild.addEventListener('click', function () { toggle(acc); });
      built.push({ acc: acc, markers: markers });
    });
    if (built.length) {
      built[0].acc.classList.add('bbm-acc-first');
      built[built.length - 1].acc.classList.add('bbm-acc-last');
    }
  }
  function disable() {
    built.forEach(function (b) {
      b.markers.forEach(function (m) { m.marker.parentNode.insertBefore(m.el, m.marker); m.marker.remove(); });
      b.acc.remove();
    });
    built = [];
    window.dispatchEvent(new Event('resize'));
  }
  function toggle(acc, open) {
    var head = acc.firstChild, body = acc.lastChild;
    open = open === undefined ? body.hidden : open;
    body.hidden = !open;
    acc.classList.toggle('is-open', open);
    head.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      // Carousels and scale drawings measure themselves; let them re-measure now they're visible.
      window.dispatchEvent(new Event('resize'));
      var r = head.getBoundingClientRect();
      if (r.top < 60) window.scrollTo({ top: window.scrollY + r.top - 76, behavior: 'smooth' });
    }
  }
  // Links to something inside a closed row (e.g. "See the 13, 15 and 18 oz vinyl") open that row first.
  function openFor(hash) {
    if (!hash || hash.length < 2) return;
    var t;
    try { t = document.querySelector(hash); } catch (e) { return; }
    var acc = t && t.closest('.bbm-acc');
    if (acc && !acc.classList.contains('is-open')) {
      toggle(acc, true);
      requestAnimationFrame(function () { t.scrollIntoView({ block: 'start' }); });
    }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#"]');
    if (!a || !built.length) return;
    var url = new URL(a.href, location.href);
    if (url.pathname === location.pathname) openFor(url.hash);
  }, true);

  function sync() { mq.matches ? enable() : disable(); }
  if (mq.addEventListener) mq.addEventListener('change', sync); else mq.addListener(sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { sync(); openFor(location.hash); });
  else { sync(); openFor(location.hash); }
})();
